var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.location
    ? _c(
        "a",
        {
          staticClass:
            "location-card w-100 h-100 text-decoration-none text-dark",
          attrs: { href: _vm.route("nl.location", { slug: _vm.location.slug }) }
        },
        [
          _c(
            "div",
            {
              staticClass: "image-wrapper",
              style: {
                "padding-top": _vm.ratio
                  ? (_vm.arHeight / _vm.arWidth) * 100 + "%"
                  : "240px"
              }
            },
            [
              _vm.location.acf && _vm.location.acf.image
                ? _c("img", {
                    staticClass: "w-100",
                    attrs: {
                      src: _vm.location.acf.image.sizes.large,
                      alt: _vm.location.title.rendered
                    }
                  })
                : _vm._e()
            ]
          ),
          _vm._v(" "),
          _c("p", {
            staticClass: "mb-0 mt-8 small",
            domProps: { innerHTML: _vm._s(_vm.location.title.rendered) }
          }),
          _vm._v(" "),
          _vm.location.acf && _vm.location.acf.bullet_points
            ? _vm._l(_vm.location.acf.bullet_points, function(
                bulletPoint,
                index
              ) {
                return _c("p", { key: index, staticClass: "xsmall" }, [
                  _vm._v(
                    "\n            " +
                      _vm._s(bulletPoint.bullet_point) +
                      "\n        "
                  )
                ])
              })
            : _vm._e(),
          _vm._v(" "),
          _vm.location.location_categories &&
          _vm.location.location_categories.length > 0
            ? _c(
                "div",
                {
                  key: _vm.location.location_categories.length,
                  ref: "categories",
                  staticClass: "tag-row mt-12"
                },
                _vm._l(_vm.location.location_categories, function(
                  category,
                  index
                ) {
                  return _c(
                    "div",
                    {
                      key: index,
                      ref: "tags",
                      refInFor: true,
                      staticClass: "tag-col"
                    },
                    [
                      _c("div", {
                        staticClass: "tag tag-accent-light tag-xs",
                        domProps: { innerHTML: _vm._s(category.name) }
                      })
                    ]
                  )
                }),
                0
              )
            : _vm._e()
        ],
        2
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }